import { render, staticRenderFns } from "./EditProductDetails.vue?vue&type=template&id=cc461f7e&scoped=true&"
import script from "./EditProductDetails.vue?vue&type=script&lang=js&"
export * from "./EditProductDetails.vue?vue&type=script&lang=js&"
import style0 from "./EditProductDetails.vue?vue&type=style&index=0&id=cc461f7e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc461f7e",
  null
  
)

export default component.exports